/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PosUserDto } from '../../models/pos-user-dto';

export interface PosTabsControllerSearchUsers$Params {
  search?: string;
}

export function posTabsControllerSearchUsers(http: HttpClient, rootUrl: string, params?: PosTabsControllerSearchUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PosUserDto>>> {
  const rb = new RequestBuilder(rootUrl, posTabsControllerSearchUsers.PATH, 'get');
  if (params) {
    rb.query('search', params.search, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PosUserDto>>;
    })
  );
}

posTabsControllerSearchUsers.PATH = '/pos/tabs/users';
